import {languageReducer} from "./language";

export const customReducers = {
    language: languageReducer
}
